/**
 * Creates boilerplate getters based on the state object and getters provided.
 *
 * @param {Object} stateObj - The state object containing properties.
 * @param {Object} getters - The object storing getters functions.
 * @returns {Object} - The updated getters object.
 */
const createGettersFactory = (stateObj, prefix = '') => {
  const getters = {};
  Object.keys(stateObj).forEach((prop) => {
    let gettersName;
    if (prop.charAt(0) === '_') {
      gettersName = `get${prefix}${prop.charAt(1).toUpperCase()}${prop.slice(2)}`;
    } else {
      gettersName = `get${prefix}${prop.charAt(0).toUpperCase()}${prop.slice(1)}`;
    }
    getters[gettersName] = (state) => state[prop];
  });
  return getters;
};

export default createGettersFactory;
